export const formatDate = (dateStr) => {
  return dateStr ? dateStr.split("T")[0] : "";
};
